/**
 * Mirrors `LegalDocuments::VERSION` / `DRAFT` on the server, which is what an
 * account's consent is stamped with. Change both together when the final texts
 * replace these placeholders.
 */
export const LEGAL_UPDATED = "2026 m. spalio 28 d.";
export const LEGAL_DRAFT = true;
